export default "__VITE_ASSET__C_jhKh1c__"